import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Analyzer, CreateAnalyzerDto } from 'types';

export const createAnalyzer = async ({
  data,
}: {
  data: CreateAnalyzerDto;
}): Promise<Analyzer> => {
  const response = await axios.post('/api/analyzers', data);
  return response.data as Analyzer;
};

type UseCreateAnalyzerOptions = {
  config?: MutationConfig<typeof createAnalyzer>;
};

export const useCreateAnalyzer = ({
  config,
}: UseCreateAnalyzerOptions = {}) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousAnalyzers) {
        queryClient.setQueryData(['analyzers'], context.previousAnalyzers);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['analyzers']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: createAnalyzer,
  });
};
